import { Component, inject, signal, ViewChild } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { GlobalButtonComponent, MenuItemComponent, DropdownSelectComponent, Option } from 'declarabid-library';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { MenuItem } from 'primeng/api';
import {
  MenuService,
  SidebarMenuItem,
} from '../../../core/services/menu.service';
import { MenuModule } from 'primeng/menu';
import { UsersService } from '../../../features/users/services/users.service';
import { AuthService } from '../../../features/auth/services/auth.service';
import { UserRole } from '../../../core/models/auth.model';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { OverlayNotificationsComponent } from '../overlay-notifications/overlay-notifications.component';
import { LanguageService } from '../../../core/services/language.service';

@Component({
  selector: 'app-navigation-bar',
  standalone: true,
  imports: [
    RouterModule,
    GlobalButtonComponent,
    AvatarModule,
    AvatarGroupModule,
    MenuItemComponent,
    MenuModule,
    OverlayPanelModule,
    OverlayNotificationsComponent,
    DropdownSelectComponent,
  ],
  templateUrl: './navigation-bar.component.html',
  styleUrl: './navigation-bar.component.scss',
})
export class NavigationBarComponent {
  @ViewChild('op') overlayPanel!: OverlayPanel;
  public readonly _usersService = inject(UsersService).currentUser();
  private readonly menuService = inject(MenuService);
  private readonly _languageService = inject(LanguageService);
  public items!: SidebarMenuItem[];
  readonly router = inject(Router);
  private readonly _authService = inject(AuthService);

  options: MenuItem[] = [
    {
      label: $localize`Mi perfil`,
      icon: 'pi pi-user',
      command: () => this.goToProfile(),
    },
    {
      label: $localize`Cerrar sesión`,
      icon: 'pi pi-sign-out',
      command: () => this._authService.logout(),
    },
  ];
  public routeUser = inject(UsersService).userRoutes();
  public currentUserRole = signal<UserRole | undefined>(undefined);
  readonly UserRole = UserRole;

  public readonly languageOptions = this._languageService.languages;
  public selectedLanguage = signal<Option>(this._languageService.getCurrentLanguageOption());

  public onHide() {
    document.body.classList.remove('no-scroll');
  }

  goToProfile() {
    console.log('Profile');
  }

  ngOnInit(): void {
    this.currentUserRole.set(this._usersService.role_value as UserRole);
    this.menuService.setMenuItems(this._usersService.role_value);
    this.menuService.getMenuItems().subscribe((menuItems) => {
      this.items = menuItems;
    });
  }


  show(event: Event) {
    this.overlayPanel.toggle(event);
    if (this.overlayPanel.overlayVisible) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
  trackByFn(index: number, item: SidebarMenuItem) {
    return item.id;
  }

  onLanguageChange(selectedOption: Option): void {
    if (selectedOption && selectedOption.value !== this._languageService.getCurrentLanguage()) {
      this._languageService.changeLanguage(selectedOption.value);
    }
  }
}
